<template>
  <div>
    <div class="d-flex align-center">
      <b>{{ $t('PLANNINGDRAWER.FIND_HERE_ACTIONS') }}</b>
      <template v-if="isPremium">
        <v-spacer></v-spacer>
        <btn-toggle-filter v-model="actionsScope.onlyMine" mandatory="force" variant="outlined" density="compact" class="mx-2">
          <v-btn :value="false" class="px-3">
            <v-icon style="width: 24px">far fa-building</v-icon>
            <v-tooltip location="bottom" activator="parent">{{ $t('PLANNINGDRAWER.ALL_ACTIONS') }}</v-tooltip>
          </v-btn>
          <v-btn :value="true" class="px-3">
            <user-avatar :user="me" :size="24"></user-avatar>
            <v-tooltip location="bottom" activator="parent">{{ $t('PLANNINGDRAWER.ONLY_MY_ACTIONS') }}</v-tooltip>
          </v-btn>
        </btn-toggle-filter>
      </template>
    </div>
    <div v-if="isPremium">
      <div v-for="el in actionsElements" class="mt-2">
        <div class="small">
          <strong :class="el.getChecklistItemClass()">{{ $filters.moment(el.getEndTime(), 'mediumDateNoYear') }}</strong>
          <span :title="`↪ ${laneLabels[el.getLaneId()] || ''}`" style="font-style: italic;" class="pointer" @click="$emit('open-element', el)">
            &nbsp;{{ el.getTitle() || $t('helpers.elDefaultTitle', { type: el.getType() }) }}
          </span>
        </div>
        <div v-for="item in elChecklist(el)" class="d-flex align-center" style="margin-left: 28px;">
          <user-avatar :user="{ id: item.user_id, group_id: item.group_id, username: item.username }" tooltip class="mr-2" style="width: 20px; margin-left: -28px"></user-avatar>
          <i class="far fa-square pointer mr-2" @click="checklistClick(el, item)"></i>
          <strong v-if="item.duedate" :class="el.getChecklistItemClass(item)" class="small mr-2">{{ $filters.moment(item.duedate, 'mediumDateNoYear') }}</strong>
          {{ item.title }}
        </div>
      </div>
      <div v-if="! actionsElements.length" class="small text-medium-emphasis mt-3">{{ $t('PLANNINGDRAWER.NO_ACTIONS') }}</div>
    </div>
    <div v-if="! isPremium" class="mt-4">
      <span>{{ $t('PREMIUM.SECTION_IS_PREMIUM') }}</span><br>
      <a :href="$t('PREMIUM.OFFERS_LINK')" target="_blank" rel="noopener">{{ $t('PREMIUM.GO_PREMIUM') }}</a>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'pinia';
  import usePlanningElementsStore from '@/stores/planning/elements';
  import useUsersStore from '@/stores/users';
  import useUsersAccessRightStore from '@/stores/users/accessRight';

  export default {
    props: {
      planning: { type: Object, required: true },
    },
    emits: ['open-element'],
    data() {
      return {
        actionsScope: { onlyMine: false },
        usersStore: useUsersStore(),
        usersAccessRightStore: useUsersAccessRightStore(),
      };
    },
    computed: {
      actionsElements() {
        const checklistItemIsActive = item => ! item.checked && (! this.actionsScope.onlyMine || item.user_id == this.me.id);
        return this.planning.elements.filter(el => el.getChecklist() && el.getChecklist().filter(checklistItemIsActive).length).sort((a, b) => (a.getEndTime() < b.getEndTime() ? -1 : 1));
      },
      laneLabels() {
        return this.planning.lanes.reduce((acc, lane) => {
          acc[lane.id] = lane.label;
          return acc;
        }, {});
      },
      isPremium() { return this.usersAccessRightStore.isPremium; },
      me() { return this.usersStore.user; },
    },
    methods: {
      elChecklist(el) {
        const checklist = el.getChecklist().filter(item => ! item.checked).sort((a, b) => (a.duedate < b.duedate ? -1 : 1));
        return ! this.actionsScope.onlyMine ? checklist : checklist.filter(item => item.user_id == this.me.id);
      },
      checklistClick(el, item) {
        this.startChangingElement();
        el.setChecklistItem(item, { checked: ! item.checked });
        el.updateChecklistProgress();
        this.changingElement(el);
      },
      ...mapActions(usePlanningElementsStore, ['startChangingElement', 'changingElement']),
    },
  };
</script>
